import React from 'react'
import ViewGreenMarkProjectList from '../../features/greenMarkProject/ViewGreenMarkProjectList'

export default function GreenMarkProject() {
  return (
    <ViewGreenMarkProjectList />
  )
}